import React from "react";
import PropTypes from "prop-types";
import styles from "./outline.module.scss";

function getPath(height, x0, x1, isFirst) {
  if (x0 === x1) return "";
  const y1 = 0 + 1;
  const y2 = height - 1;
  const isAsc = x0 < x1;
  const padding = 1.6;
  const m1 = isAsc ? 1 : -1;
  const m2 = isFirst ? 1 : -1;
  const a = isFirst && isAsc;
  const b = !isFirst && !isAsc;
  const m3 = a || b ? 0 : 1;
  const m4 = a || b ? 1 : 0;
  const p = padding * m1 * m2;
  const p1 = p * m4;
  const p2 = p * m3;
  const start = p1 + (isAsc ? x0 : x1);
  const end = p2 + (isAsc ? x1 : x0);
  const y = (y2 - y1) / 2 + 1;
  const optimalR = y * 0.5;
  const maxR = (end - start) / 4;
  const r = Math.min(optimalR, maxR);
  const s = start + r;
  const e = end - r;
  return `
    M${s},${y1}
    L${e},${y1}
    Q${e + 2 * r},${y} ${e},${y2}
    L${s},${y2}
    Q${s - 2 * r},${y} ${s},${y1} z
  `;
}

function BandOutline({ height, x1, x2, x3 }) {
  const arm1 = getPath(height, x1, x2, true);
  const arm2 = getPath(height, x2, x3, false);
  const outline = arm1 + arm2;

  return (
    <path
      d={outline}
      className={`${styles.armOutline} tw-stroke-current tw-text-indigo-500 tw-opacity-50`}
    />
  );
}

BandOutline.propTypes = {
  height: PropTypes.number.isRequired,
  x1: PropTypes.number.isRequired,
  x2: PropTypes.number.isRequired,
  x3: PropTypes.number.isRequired,
};

export default React.memo(BandOutline);
